import React, { useEffect, useRef, useState } from 'react';

type AnimatedNumberProps = {
  value: number;
  formatFn?: (n: number) => string;
};

const AnimatedNumber: React.FC<AnimatedNumberProps> = ({ value, formatFn = (n) => n.toLocaleString() }) => {
  const [displayValue, setDisplayValue] = useState<number>(value);
  const previousValue = useRef<number>(value);
  const duration = 500;

  useEffect(() => {
    const start = performance.now();
    const from = previousValue.current;
    const to = value;

    const animate = (now: number) => {
      const elapsed = now - start;
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3); // easeOutCubic
      const current = from + (to - from) * eased;
      setDisplayValue(current);

      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };

    requestAnimationFrame(animate);
    previousValue.current = value;
  }, [value, duration]);

  return <span>{formatFn(displayValue)}</span>;
};

export default AnimatedNumber;
